<template>

  <div class="driver-summary-top" :style="{height:contentHeight+'px'}">
    <div class="driver-summary-top-left-item" v-if="leftTab==1">
      <div class="label">创建人</div>
      <div class="val">{{model.createByName}}</div>
    </div>
      <div class="driver-summary-top-left-item"  v-if="leftTab==1">
        <div class="label">创建时间</div>
        <div class="val">{{model.createTime}}</div>
      </div>
    <div class="driver-summary-top-left-item"  v-if="leftTab==2">
      <div class="label">年度累计单量({{year}})</div>
      <div class="val">{{model.gmvStatistics.yearOrder}}</div>
    </div>
    <div class="driver-summary-top-left-item"  v-if="leftTab==2">
      <div class="label">年度总计流水</div>
      <div class="val">{{model.gmvStatistics.yearIncome}}</div>
    </div>
    <div class="driver-summary-top-left-item"  v-if="leftTab==2">
      <div class="label">总累计单量</div>
      <div class="val">{{model.gmvStatistics.totalOrder}}</div>
    </div>
    <div class="driver-summary-top-left-item"  v-if="leftTab==2">
      <div class="label">总总计流水</div>
      <div class="val">{{model.gmvStatistics.totalIncome}}</div>
    </div>

  </div>
</template>

<script>


  export default {
    name: 'PlatformInfoTopNew',
    props: {
      model:{
        type:Object,
        default:{}
      },
      leftTab:{
        type:Number,
        default:1
      }
    },
    data(){
      return {
        contentHeight:document.documentElement.clientHeight-276,
        year:new Date().getFullYear()
      }
    },methods:{

    }
  }
</script>
<style lang="less" scoped>


  .driver-summary-top{
    background: #fff;
    border-radius: 12px;
    margin-top: 24px;
    padding: 20px;
  }

  .driver-summary-top  .driver-summary-top-left-item{
    padding-bottom: 24px;
  }
  .driver-summary-top-left-item .label{
    color: rgba(145, 146, 158, 1);
    font-size: 16px;
  }
  .driver-summary-top-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
    margin-top: 10px;
  }
  .driver-summary-top-left-item img{
    width: 16px;
    height: 16px;
    margin-left: 30px;
  }
  .driver-summary-top-left-item .time{
    font-size: 12px;
    font-weight: 400;
    color: rgba(63, 140, 255, 1);
  }
  .driver-summary-top-btn{
    width: 145px;
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: rgba(63, 140, 255, 1);
  }
  .driver-summary-top-btn img{
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
</style>